import { BASE_USER_ROLES, USER_ROLE_IDS } from '@/common/constants/user';
import { CategoryContentType, ContentVariantType, AnchorType } from '../types';

export const RECOMMENDED_VIDEOS_TITLTE_SUPPORTER_AND_SURVIVOR =
  'Recommended Supporter Videos';

export const CONTENT_CATEGORY: { [key: string]: CategoryContentType } = {
  All: 'all',
  Tools: 'tools',
  Community: 'community',
  Wishlist: 'wishlist',
  Shop: 'shop',
  Insurance: 'insurance',
  ManageVillage: 'manage-village',
};

export const CONTENT_ORDERS = {
  [BASE_USER_ROLES.PATIENT]: [
    CONTENT_CATEGORY.Wishlist,
    CONTENT_CATEGORY.Shop,
    CONTENT_CATEGORY.ManageVillage,
    CONTENT_CATEGORY.Insurance,
    CONTENT_CATEGORY.Tools,
    CONTENT_CATEGORY.Community,
  ],
  [BASE_USER_ROLES.SUPPORTER]: [
    CONTENT_CATEGORY.Wishlist,
    CONTENT_CATEGORY.Shop,
    CONTENT_CATEGORY.ManageVillage,
    CONTENT_CATEGORY.Community,
    CONTENT_CATEGORY.Tools,
  ],
  [BASE_USER_ROLES.SURVIVOR]: [
    CONTENT_CATEGORY.Community,
    CONTENT_CATEGORY.Tools,
  ],
};

const contentCategory = {
  [CONTENT_CATEGORY.All]: {
    title: 'All',
    category: CONTENT_CATEGORY.All,
    path: '/u/[villageId]',
    hasSlug: true,
  },
  [CONTENT_CATEGORY.Community]: {
    title: 'Community',
    category: CONTENT_CATEGORY.Community,
    path:
      'https://community.stage.onevillage.io/user/security-signin/onevillage',
    hasSlug: false,
  },
  [CONTENT_CATEGORY.Tools]: {
    title: 'Tools',
    category: CONTENT_CATEGORY.Tools,
    path: '/tools',
    hasSlug: false,
  },
  [CONTENT_CATEGORY.Wishlist]: {
    title: 'WishList',
    category: CONTENT_CATEGORY.Wishlist,
    path: '/wishlist/[villageId]',
    hasSlug: true,
  },
  [CONTENT_CATEGORY.Shop]: {
    title: 'Shop',
    category: CONTENT_CATEGORY.Shop,
    path: '/collections',
    hasSlug: false,
  },
  [CONTENT_CATEGORY.Insurance]: {
    title: 'Insurance Benefits',
    category: CONTENT_CATEGORY.Insurance,
    path: '/advice-and-support/insurance',
    hasSlug: false,
  },
  [CONTENT_CATEGORY.ManageVillage]: {
    title: 'Manage Village',
    category: CONTENT_CATEGORY.ManageVillage,
    path: '/vlg/[villageId]/villagers',
    hasSlug: true,
  },
};

export const CONTENT_VARIANTS: {
  [key: string]: ContentVariantType;
} = contentCategory;

export const ANCHOR_VARIANTS: {
  [key: string]: AnchorType;
} = contentCategory;

export const PERSONALIZED_TOOL_IDS = {
  [USER_ROLE_IDS[BASE_USER_ROLES.PATIENT]]: [1, 2, 3, 4, 5],
  [USER_ROLE_IDS[BASE_USER_ROLES.SURVIVOR]]: [5, 6],
  [USER_ROLE_IDS[BASE_USER_ROLES.SUPPORTER]]: [1, 2, 3, 4, 5],
  [USER_ROLE_IDS[BASE_USER_ROLES.SUPPORTER] +
  USER_ROLE_IDS[BASE_USER_ROLES.PATIENT]]: [1, 2, 3, 4, 5],
  [USER_ROLE_IDS[BASE_USER_ROLES.SUPPORTER] +
  USER_ROLE_IDS[BASE_USER_ROLES.SURVIVOR]]: [1, 2, 3, 4, 5, 6],
  [USER_ROLE_IDS[BASE_USER_ROLES.PATIENT] +
  USER_ROLE_IDS[BASE_USER_ROLES.SURVIVOR]]: [1, 3, 4, 5, 6],
};

export const LOGO_SRC = '/images/logos-carousel/';

export const CAROUSEL_LOGO_IMAGES = [
  'uber.svg',
  'twitch.svg',
  'headspace.svg',
  'sunbasket.svg',
  'airbnb.svg',
  'instacart.svg',
  'doordash.svg',
  'patch_10.svg',
  'jeenie.svg',
  'not_just.svg',
  'curious_cardinals.svg',
  'bien-mal.svg',
  'breakaway-matcha.svg',
  'hygge.svg',
  'survivor-eyes.svg',
];
